import { useEffect, useState } from "react";
import $ from 'jquery'
import validator from 'validator'
import countrycode from '../../../config/countyCode.json'
import qrcountrycode from '../../../config/qrcounrtyCode.json'
import categoriesMap from '../../../config/categories.json'
import { useLocation } from "react-router-dom";
import { toast } from 'react-toastify';
import { auth, db, RecaptchaVerifier, signInWithPhoneNumber, collection, addDoc, doc, setDoc, getDoc } from '../../../config/firebase'
import { v4 as uuidv4 } from 'uuid';
import youtube from '../../../images/Thumbnail2.jpg';
import background3 from '../../../images/background3.jpg';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Iframe from 'react-iframe';	

const Form = (props)=> {    
    const [name, SetName] = useState('');
    const [email, SetEmail] = useState('');
    const [company, setCompany] = useState('');
    const [categories, SetCategories] = useState('Self Storage');
    const [phone, SetPhone] = useState();
    const [otp, SetOtp] = useState();
    const [contry, SetContry] = useState('+1');
    const [otpresult, SetOtpresult] = useState('')
    const [otpsent, setotpsent] = useState(false);
    const [err, SetErr] = useState(false);
    const [dis, SetDis] = useState(false);
    const [uuid, SetUuid] = useState(uuidv4());
    const location = useLocation()
    const params = new URLSearchParams(location.search)

    const delay = ms => new Promise(res => setTimeout(res, ms));


    const date = new Date();
    const showTime = date.getHours()
        + ':' + date.getMinutes()
        + ":" + date.getSeconds();
    const showDate = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();


    const CancelPhoneVerification = (e) => {
        e.preventDefault()
        setotpsent(false);
        SetPhone('')
        SetDis(false)
        $('#recaptcha-container').html('');
        $('#SendOtpBtn').removeClass('cursorNotAllowed')
    }

    const generateRecaptcha = () => {
        window.applicationVerifier = new RecaptchaVerifier('recaptcha-container', {}, auth);
    }

    const SendOTp = async (e) => {
        if (name === '' || email === '' || company === '') {
           
            console.log('Null '+validator.isEmail(email))
            SetErr(true);
            return
        } else if(validator.isEmail(email) === false){
            console.log('Email Valid'+validator.isEmail(email))
            SetErr(true);
            return
        }
        e.preventDefault()
        let phoneNumber = contry + phone
        if (phoneNumber === "" || phoneNumber.length < 10) return;
        generateRecaptcha();
        const docSnap = await getDoc(doc(db, 'Users', phone));
        if (docSnap.exists()) {
            addData(uuid, false, true);
        } else {
            addUserList()
            addData(uuid, false, true);
        }
        let appVerifier = window.applicationVerifier;
        signInWithPhoneNumber(auth, phoneNumber, appVerifier)
            .then((confirmationResult) => {
                window.confirmationResult = confirmationResult;
                $('#SendOtpBtn').addClass('cursorNotAllowed')
                SetOtpresult(confirmationResult);
                $('#recaptcha-container').html('')
                setotpsent(true)
                SetDis(true)
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const ValidateOtp = (e) => {
        e.preventDefault()
        if (otp === null || otpresult === null)
            return;
        let confirmationResult = window.confirmationResult;
        confirmationResult.confirm(otp).then((result) => {
            addData(uuid, true, false);
        }).catch((error) => {
            alert(error);
            window.location.reload()
        });
    }

    const addUserList = async (uuid) => {
        const docRef = await setDoc(doc(db, "Users", contry + phone), {
            name: name,
            number: contry + phone,
            email: email,
            company: company,
            date: showDate,
            time: showTime,
            create_at: Date.now()
        });
    }

    const addData = async (uid, verified, isOtp) => {
        const docRef = await setDoc(doc(db, "Leads", uid), {
            id: uid,
            name: name,
            email: email,
            company: company,
            number: contry + phone,
            date: showDate,
            time: showTime,
            otp: verified,
            categories: categories,
            leadstatus: '',
            leadvalue: '',
            leadinterest: '',
            utm_source: params.get("utm_source"),
            utm_medium: params.get("utm_medium"),
            utm_campaign: params.get("utm_campaign"),
            utm_id: params.get("utm_id"),
            create_at: Date.now()
        }).then((docRef) => {
            if (isOtp) {
                toast.success('OTP Sent to Your Mobile No');
            } else {
                toast.success('Thank you for your submission We will contact you shortly! For any queries, please reach out to contact support@6storage.com');
                reloadFunction();

            }
        }).catch((error) => {
            toast.error('Something Problem !!!');
        });
    }

    const reloadFunction = async () => {
        await delay(5555);
        window.location.reload();
    };


    return (
        <>
            <div style={{ background: `url(${background3})`, backgroundSize: 'cover', }}>
                <div className="container p-4">
                    <div className="row">
                        <div className="col-md-7 text-white h-100 px-2">
                            <div className="px-lg-4 py-3 my-2">
                                <h2 className="mb-3 text-break">6X Your Business Growth With Advanced Self Storage Software</h2>
                                <h5 className="mb-3 lh-base text-break">6Storage is a one-stop shop to manage all storage and facility operations, security, and tenant focused solutions.</h5>
                                <button class="position-relative btn btn-primary" type="button" data-bs-toggle="modal" data-bs-target="#exampleModal">
                                    <LazyLoadImage className='w-100' effect="blur" src={youtube}/>
                                    <span class="position-absolute d-flex align-items-center justify-content-center w-100 h-100 top-0 left-0 right-0 bottom-0" aria-hidden="true">
                                        <svg style={{ width: '80px', height: '80px', }} class="w-20 h-20 text-white rounded-full shadow-xl" fill="currentColor" viewBox="0 0 84 84">
                                            <circle opacity="0.95" cx="42" cy="42" r="42" fill="red"></circle>
                                            <path d="M55.5039 40.3359L37.1094 28.0729C35.7803 27.1869 34 28.1396 34 29.737V54.263C34 55.8604 35.7803 56.8131 37.1094 55.9271L55.5038 43.6641C56.6913 42.8725 56.6913 41.1275 55.5039 40.3359Z"></path>
                                        </svg>
                                    </span>
                                </button>
                                <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                    <div class="modal-dialog modal-dialog-centered modal-lg">
                                        <div class="modal-content">
                                            <div class="modal-body">
                                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                                <Iframe className="popup w-100" src="https://www.youtube.com/embed/_MSH5iAUbBM?start=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></Iframe>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 p-lg-3 br-20 background-grey">
                            <div className="row">
                                <div className="col-12 my-3">
                                    <label className="formMandatory mb-2"> Full Name </label>
                                    <input value={name} onChange={e => SetName(e.target.value)} className="form-control" type="text" disabled={dis} />
                                    {err && name === '' ?
                                        <div className="invalid-feedback d-block position-absolute">
                                            Full Name
                                        </div> : <></>}
                                </div>
                                <div className="col-12 my-3">
                                    <label className="formMandatory mb-2">  Work E-Mail </label>
                                    <input value={email} onChange={e => SetEmail(e.target.value)} className="form-control" type="email" disabled={dis} />
                                    {err && email === '' && validator.isEmail(email) === false ?
                                        <div className="invalid-feedback d-block position-absolute">
                                            Enter Valid email
                                        </div> : err && validator.isEmail(email) === false ?
                                        <div className="invalid-feedback d-block position-absolute">
                                            Enter Valid email
                                        </div> : <></>}
                                </div>
                                <div className="col-12 my-3">
                                    <label className="formMandatory mb-2">  Company  </label>
                                    <input value={company} onChange={e => setCompany(e.target.value)} className="form-control" type="text" disabled={dis} />
                                    {err && company === '' ?
                                        <div className="invalid-feedback d-block position-absolute">
                                            Company
                                        </div> : <></>}
                                </div>
                                {/* <div className="col-12 my-3">
                                    <label className="formMandatory mb-2">  Country  </label>
                                    <select value={contry} onChange={e => SetContry(e.target.value)} className="form-control" >
                                        {countrycode.map((option) => (
                                            <option value={option.value}>{option.label}</option>
                                        ))}
                                    </select>
                                </div> */}
                                <div className="col-12 my-3">
                                    <label className="formMandatory mb-2">  Categories  </label>
                                    <select value={categories} onChange={e => SetCategories(e.target.value)} className="form-control" >
                                        {categoriesMap.map((option) => (
                                            <option value={option.value}>{option.label}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-12 my-3 position-relative">
                                    <label className="formMandatory mb-2"> Phone Number  </label>
                                    <div class="input-group mb-3">
                                       
                                            {props.data === 'ssaa'?
                                        <select value={contry} onChange={e => SetContry(e.target.value)} className="input-group-text p-0" >
                                        
                                            {countrycode.map((option) => (
                                                <option value={option.dial_code}>{option.flag}{option.dial_code}</option>
                                            ))}
                                        </select>:
                                        <select value={contry} onChange={e => SetContry(e.target.value)} className="input-group-text p-0" >
                                        
                                        {qrcountrycode.map((option) => (
                                            <option value={option.dial_code}>{option.flag}{option.dial_code}</option>
                                        ))}
                                    </select>}
                                        <input
                                            type="number"
                                            onInput={(e) => {
                                                if (e.target.value.length > e.target.maxLength)
                                                    e.target.value = e.target.value.slice(0, e.target.maxLength);
                                            }}
                                            onChange={e => SetPhone(e.target.value)} class="form-control numberinput"
                                            value={phone}
                                            maxLength={10}
                                            disabled={dis}
                                        />
                                        {otpsent && <svg onClick={e => CancelPhoneVerification(e)} style={{ right: '120px', top: '10px' }} className="position-absolute" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="20px" height="20px"><linearGradient id="wRKXFJsqHCxLE9yyOYHkza" x1="9.858" x2="38.142" y1="9.858" y2="38.142" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#f44f5a" /><stop offset=".443" stop-color="#ee3d4a" /><stop offset="1" stop-color="#e52030" /></linearGradient><path fill="url(#wRKXFJsqHCxLE9yyOYHkza)" d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z" /><path d="M33.192,28.95L28.243,24l4.95-4.95c0.781-0.781,0.781-2.047,0-2.828l-1.414-1.414	c-0.781-0.781-2.047-0.781-2.828,0L24,19.757l-4.95-4.95c-0.781-0.781-2.047-0.781-2.828,0l-1.414,1.414	c-0.781,0.781-0.781,2.047,0,2.828l4.95,4.95l-4.95,4.95c-0.781,0.781-0.781,2.047,0,2.828l1.414,1.414	c0.781,0.781,2.047,0.781,2.828,0l4.95-4.95l4.95,4.95c0.781,0.781,2.047,0.781,2.828,0l1.414-1.414	C33.973,30.997,33.973,29.731,33.192,28.95z" opacity=".05" /><path d="M32.839,29.303L27.536,24l5.303-5.303c0.586-0.586,0.586-1.536,0-2.121l-1.414-1.414	c-0.586-0.586-1.536-0.586-2.121,0L24,20.464l-5.303-5.303c-0.586-0.586-1.536-0.586-2.121,0l-1.414,1.414	c-0.586,0.586-0.586,1.536,0,2.121L20.464,24l-5.303,5.303c-0.586,0.586-0.586,1.536,0,2.121l1.414,1.414	c0.586,0.586,1.536,0.586,2.121,0L24,27.536l5.303,5.303c0.586,0.586,1.536,0.586,2.121,0l1.414-1.414	C33.425,30.839,33.425,29.889,32.839,29.303z" opacity=".07" /><path fill="#fff" d="M31.071,15.515l1.414,1.414c0.391,0.391,0.391,1.024,0,1.414L18.343,32.485	c-0.391,0.391-1.024,0.391-1.414,0l-1.414-1.414c-0.391-0.391-0.391-1.024,0-1.414l14.142-14.142	C30.047,15.124,30.681,15.124,31.071,15.515z" /><path fill="#fff" d="M32.485,31.071l-1.414,1.414c-0.391,0.391-1.024,0.391-1.414,0L15.515,18.343	c-0.391-0.391-0.391-1.024,0-1.414l1.414-1.414c0.391-0.391,1.024-0.391,1.414,0l14.142,14.142	C32.876,30.047,32.876,30.681,32.485,31.071z" /></svg>}
                                        <button class="btn btn-success p-1" style={{ fontSize: '12px' }} id="SendOtpBtn" onClick={e => SendOTp(e)}>Verification</button>
                                    </div>
                                </div>
                                <div id="recaptcha-container"></div>
                                {otpsent &&
                                    <div className="col-12" >
                                        <div className="col-12 my-3">
                                            <label className="formMandatory mb-2">  OTP  </label>
                                            <input value={otp} onChange={e => SetOtp(e.target.value)} type="number" class="form-control numberinput"
                                                onInput={(e) => {
                                                    if (e.target.value.length > e.target.maxLength)
                                                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                                                }}
                                                maxLength={6}
                                            />
                                        </div>
                                        <div className="col-12 mt-5 text-center" >
                                            <button onClick={e => ValidateOtp(e)} className="btn text-white px-4 br-20" style={{ background: '#FA1378' }}>Get a Free Demo</button>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}


export default Form;